import { jsx as _jsx } from "react/jsx-runtime";
import { SystemMessage } from '@alfalab/core-components/system-message';
export const Controls = ({ children, ...props }) => (_jsx(SystemMessage.Controls, { ...props, children: children }));
Controls.displayName = 'Controls';
